"use client";

import { ArrowLeft, ShoppingCart } from "lucide-react";

import { usePageTranslation } from "@/hooks/usePageTranslation";

interface EmptyCartProps {
  onContinueShopping: () => void;
}

export function EmptyCart({ onContinueShopping }: EmptyCartProps) {
  const { t } = usePageTranslation();

  return (
    <div className="empty-cart flex min-h-[60vh] items-center justify-center">
      <div className="container mx-auto px-4 py-12">
        <div className="mx-auto max-w-md text-center">
          <div className="empty-cart__icon mb-6 flex justify-center">
            <div className="flex h-24 w-24 items-center justify-center rounded-full bg-brand-fg/5">
              <ShoppingCart className="h-12 w-12 text-brand-muted/70" />
            </div>
          </div>

          <h1 className="empty-cart__title mb-4 text-3xl font-bold text-brand-fg">
            {t("cart.empty")}
          </h1>

          <p className="empty-cart__description mb-8 text-brand-muted">
            {t("cart.emptyDescription")}
          </p>

          <button
            onClick={onContinueShopping}
            className="empty-cart__cta inline-flex items-center gap-2 rounded-brand bg-brand-primary px-8 py-3 font-semibold text-brand-primary-foreground shadow-md transition-colors hover:bg-brand-primary-hover hover:shadow-lg"
          >
            <ArrowLeft className="h-5 w-5 rtl:rotate-180" />
            {t("cart.startShopping")}
          </button>
        </div>
      </div>
    </div>
  );
}
